/**
 * Returns the URL to be used on the "View all results" pre-search link
 *
 * @param {string} searchTerm The term that was searched for
 * @param {string} searchType The category in which the search was performed
 * @param {array} data The results that were found for the search
 * @returns {string} The URL to be used on the link
 */
function allSearchResultURL(searchTerm, searchType) {
  var searchTypeSlug = "";

  // TODO: check these!
  switch (searchType) {
    case jack_constants.PRODUCTS:
      searchTypeSlug = "products";
      break;
    case jack_constants.INSPIRATION_AND_ADVICE:
      // TODO: is this the right format?
      searchTypeSlug = "inspiration-and-advice";
      break;
    // TODO: is this the right format?
    case jack_constants.FAQS:
      searchTypeSlug = "faqs";
      break;
    case jack_constants.ALL_SITE:
      break;
    default:
      break;
  }

  var searchURL = "/?s=" + encodeURIComponent(searchTerm);

  if (searchTypeSlug) {
    searchURL += "&search_type=" + encodeURIComponent(searchTypeSlug);
  }

  return searchURL;
}

jQuery(function ($) {
  var currentSearchRequest = null;
  var spellCheckRequest = null;

  /**
   * Call spell check api endpoint, handle results
   * @param {*} preSearchTerm user input search term
   * @param {*} searchType user selected search type
   * @returns Will return early, if search type is for traders
   */
  function performSpellCheck(preSearchTerm, searchType) {
    var loadingIcon = $(".search-input__loading-icon");
    var searchIcon = $(".search-input__icon");

    var searchURLBase = "/wp-json/jack-search/v1/spell-check";
    var queryString = "?s=" + preSearchTerm;
    var spellCheckURL = searchURLBase + queryString;

    loadingIcon.addClass("active-spell-check");
    searchIcon.addClass("active-spell-check");

    spellCheckRequest = $.ajax({
      type: "get",
      url: spellCheckURL,
      beforeSend: function () {
        // Handle aborting old spell check requests, if this one is in progress
        if (spellCheckRequest != null) {
          spellCheckRequest.abort();
        }
      },
      success: function (data) {
        loadingIcon.removeClass("active-spell-check");
        searchIcon.removeClass("active-spell-check");
        appendSpellCheckResults(data);
      },
      failure: function () {
        loadingIcon.removeClass("active-spell-check");
        searchIcon.removeClass("active-spell-check");
      },
    });
  }

  /**
   * Call search endpoint, handle results
   *
   * @param {string} preSearchTerm user input search term
   * @param {*} searchType user input search type
   */
  function performSearch(preSearchTerm, searchType) {
    var endpoint = "all-site";
    var loadingIcon = $(".search-input__loading-icon");
    var searchIcon = $(".search-input__icon");

    // TODO: check these!
    switch (searchType) {
      case jack_constants.PRODUCTS:
        endpoint = "products";
        break;
      case jack_constants.INSPIRATION_AND_ADVICE:
        endpoint = "inspiration-and-advice";
        break;
      case jack_constants.FAQS:
        endpoint = "faqs";
        break;
      case jack_constants.ALL_SITE:
        endpoint = "all-site";
        break;
      default:
        break;
    }

    var searchURLBase = "/wp-json/jack-search/v1/";
    var queryString = "?s=" + preSearchTerm;
    var searchURL = searchURLBase + endpoint + queryString;

    searchIcon.addClass("active");
    loadingIcon.addClass("active");

    currentSearchRequest = $.ajax({
      type: "get",
      url: searchURL,
      beforeSend: function () {
        // Handle aborting old search requests, if this one is in progress
        if (currentSearchRequest != null) {
          currentSearchRequest.abort();
        }
      },
      success: function (data) {
        searchIcon.removeClass("active");
        loadingIcon.removeClass("active");
        appendSearchResults(preSearchTerm, searchType, data);
      },
      failure: function () {
        searchIcon.removeClass("active");
        loadingIcon.removeClass("active");
      },
    });
  }

  /**
   * Perform Search action
   */
  function setUpSearch() {
    var preSearchTerm = $(".search-input__input").val();
    var searchType = $("#search-dropdown-input").val();

    if (preSearchTerm && searchType) {
      performSearch(preSearchTerm, searchType);
    }
  }

  /**
   * Perform Spell Check action
   */
  function setUpSpellCheck() {
    var preSearchTerm = $(".search-input__input").val();
    var searchType = $("#search-dropdown-input").val();

    if (preSearchTerm && searchType) {
      performSpellCheck(preSearchTerm, searchType);
    }
  }

  /**
   * Set link on Orange Search button
   */
  function setSearchLink() {
    var preSearchTerm = $(".search-input__input").val();
    var searchType = $("#search-dropdown-input").val();
    var $searchButton = $(".search-input__search-button");

    var searchLink = allSearchResultURL(preSearchTerm, searchType);

    $searchButton.attr("href", searchLink);
  }

  $(document).ready(function () {
    setSearchLink();
  });

  /**
   * Events tied to typing in search box
   */
  $(document).on(
    "keyup",
    ".search-input__input",
    debounce(function () {
      setUpSearch();
      setSearchLink();
      setUpSpellCheck();
    }, 150)
  );

  /**
   * Handle exiting search input on "enter"
   */
  $(document).on("keyup", ".search-input__input", function (event) {
    event.preventDefault();
    if (event.which === 13) {
      $(this).blur();
    }
  });

  /**
   * Events tied to changing search type
   */
  $(document).on("change", "#search-dropdown-input", function () {
    setUpSearch();
    setSearchLink();
  });

  /**
   * Events tied to selecting suggested search term
   */
  $(document).on("click", ".search-container__did-you-mean", function (e) {
    e.preventDefault();
    var dataTerm = $(this).attr("data-term");

    $(".search-input__input").val(dataTerm);

    setUpSearch();
    setSearchLink();

    clearSpellCheckResults();
  });

  function displaySpellCheckResults(data) {
    var $didYouMean = $(".search-container__did-you-mean");
    var $didYouMeanTerm = $(".search-container__did-you-mean-term");

    $didYouMean.removeClass("hidden").attr("data-term", data);
    $didYouMeanTerm.html(data);
  }

  function clearSpellCheckResults() {
    var $didYouMean = $(".search-container__did-you-mean");
    var $didYouMeanTerm = $(".search-container__did-you-mean-term");

    $didYouMean.addClass("hidden").attr("data-term", "");
    $didYouMeanTerm.html("");
  }

  function appendSpellCheckResults(data) {
    if (data && data.length) {
      displaySpellCheckResults(data);
    } else {
      clearSpellCheckResults();
    }
  }

  /**
   * Link type definition
   * @typedef {Object} Link
   * @property {string} title Title of the Link Object
   * @property {string} url URL of the Link Object
   */
  /**
   * Icon type definition
   * @typedef {Object} Icon
   * @property {string} type The type of the Icon, either 'result' or 'total'
   * @property {string} url URL of the Link Object
   * @property {string} altUrl URL of image to show when hovered
   */

  /**
   * Display a single search result
   * @param {Icon} icon The Icon to be displayed
   * @param {string} title HTML string, containing the title of the search result
   * @param {Link} sourceLink Object containing the title and URL of the search result
   * @param {string|array[string]} extraClass Additional class names to be added to the root `search-result` element. Use array of strings if multiple
   */
  function displayResult(title, link, extraClass) {
    var result = document.createElement("li");
    result.classList.add("search-result");
    if (extraClass) {
      if (Array.isArray(extraClass)) {
        extraClass.forEach(function (newClass) {
          result.classList.add(newClass);
        });
      } else {
        result.classList.add(extraClass);
      }
    }

    var linkElement = document.createElement("a");
    linkElement.href = link.url;
    linkElement.classList.add("search-result__wrapper");
    result.appendChild(linkElement);

    // Display title
    var titleElement = document.createElement("span");
    titleElement.classList.add("search-result__title");
    titleElement.innerHTML = title;
    linkElement.appendChild(titleElement);

    // Display link
    var viewElement = document.createElement("span");
    viewElement.classList.add("search-result__link");

    var innerViewElement = document.createElement("span");

    var innerViewTextElement = document.createElement("span");
    innerViewTextElement.classList.add("text");
    innerViewTextElement.innerHTML = link.title;

    innerViewElement.appendChild(innerViewTextElement);
    viewElement.appendChild(innerViewElement);
    linkElement.appendChild(viewElement);

    var resultsList = document.getElementById("search-container__results");

    resultsList.appendChild(result);
  }

  function displayTotalResults(preSearchTerm, searchType, data) {
    var collectiveString = data.total === 1 ? "is" : "are";
    var resultsString = data.total === 1 ? "result" : "results";
    var totalResultsTitle =
      "<span class='search-result__prefix'>There " +
      collectiveString +
      " </span><strong>" +
      data.total +
      "&nbsp;" +
      resultsString +
      "</strong> in <strong>" +
      jack_constants.ALL_SITE +
      "</strong>";
    var classes = ["search-result--all", "has-alt"];
    var allResultsTitle = "View all results";

    if (data.total <= 4 && searchType !== jack_constants.ALL_SITE) {
      classes.push("search-result--toggle-all");
      allResultsTitle = "Try Searching All Site";
    }

    displayResult(
      totalResultsTitle,
      {
        title: allResultsTitle,
        url: allSearchResultURL(preSearchTerm, searchType),
      },
      classes
    );
  }

  /**
   * Loop over search results and trigger display function
   *
   * @param {object} data Object containing search results
   */
  function displayDefaultResults(data) {
    data.posts.forEach(function (post) {
      displayResult(post.post_title, post.link);
    });
  }

  function allSearchResultTitle(title, count) {
    var collectiveString = count === 1 ? "is" : "are";
    var resultsString = count === 1 ? "result" : "results";
    return (
      "<span class='search-result__prefix'>There " +
      collectiveString +
      " </span><strong>" +
      count +
      "&nbsp;" +
      resultsString +
      "</strong> in <strong>" +
      title +
      "</strong>"
    );
  }

  function displayAllSearchResults(searchTerm, data) {
    var productsTItle = allSearchResultTitle(
      jack_constants.PRODUCTS,
      data.products.total
    );
    displayResult(
      productsTItle,
      {
        title: "View",
        url: allSearchResultURL(searchTerm, jack_constants.PRODUCTS),
      },
      "has-alt"
    );

    var inspirationAndAdviceTitle = allSearchResultTitle(
      jack_constants.INSPIRATION_AND_ADVICE,
      data.inspiration_and_advice.total
    );
    displayResult(
      inspirationAndAdviceTitle,
      {
        title: "View",
        url: allSearchResultURL(
          searchTerm,
          jack_constants.INSPIRATION_AND_ADVICE
        ),
      },
      "has-alt"
    );

    var faqsTitle = allSearchResultTitle(jack_constants.FAQS, data.faqs.total);
    displayResult(
      faqsTitle,
      {
        title: "View",
        url: allSearchResultURL(searchTerm, jack_constants.NEWS_AND_MORE),
      },
      "has-alt"
    );
  }

  /**
   * Displays search results to the user
   *
   * @param {object} data Search results from Pre-Search api endpoints
   */
  function appendSearchResults(preSearchTerm, searchType, data) {
    clearResults();
    if (data && data.total > 0) {
      switch (searchType) {
        case jack_constants.PRODUCTS:
        case jack_constants.INSPIRATION_AND_ADVICE:
        case jack_constants.FAQS:
          displayDefaultResults(data);
          break;
        case jack_constants.ALL_SITE:
          displayAllSearchResults(preSearchTerm, data);
          break;
        default:
          break;
      }
    }

    displayTotalResults(preSearchTerm, searchType, data);
  }

  /**
   * Handle clearing pre-search results
   */
  function clearResults() {
    var resultsList = document.getElementById("search-container__results");
    resultsList.innerHTML = "";
  }

  $(document).on("mouseover", ".has-alt", function () {
    var img = $(this).find(".search-result__img");
    var src = img.attr("data-alt-src");
    img.attr("src", src);
  });

  $(document).on("mouseout", ".has-alt", function () {
    var img = $(this).find(".search-result__img");
    var src = img.attr("data-src");
    img.attr("src", src);
  });

  // Toggle action on "View all results" link to change search type to "All Results"
  $(document).on(
    "click",
    ".search-result--toggle-all .search-result__wrapper",
    function (e) {
      e.preventDefault();
      var input = $("#search-dropdown-input");
      input.val(jack_constants.ALL_SITE).trigger("change");
    }
  );

  // Sets search filter to "SHOP ONLINE" when a product is added to the cart
  $(document).on("click", ".shop-btn--add-to-cart", function (e) {
    var input = $("#search-dropdown-input");
    input.val(jack_constants.PRODUCTS).trigger("change");
  });
});

// ! MOVED FROM SEARCH RESULTS
jQuery(function ($) {});
